module.exports = __webpack_public_path__ + "img/share.cbe3cc26.svg";